// 💾 src/pages/admin/Dashboard.tsx
import { useState } from "react"
import AdminSidebar from "./components/AdminSidebar"
import DashboardPanel from "./components/sections/DashboardPanel"
import UsersPanel from "./components/sections/UsersPanel"
import TradesPanel from "./components/sections/TradesPanel"
import WithdrawalsPanel from "./components/sections/WithdrawalsPanel"
import SettingsPanel from "./components/sections/SettingsPanel"
import DepositsPanel from "./components/sections/DepositsPanel"

import "./style/Dashboard.scss"

const Dashboard = () => {
  const [section, setSection] = useState<
    "dashboard" | "users" | "trades" | "deposits" | "withdrawals" | "settings"
  >("dashboard")

  const renderPanel = () => {
    switch (section) {
      case "users":
        return <UsersPanel />
      case "trades":
        return <TradesPanel />
      case "deposits":
        return <DepositsPanel />
      case "withdrawals":
        return <WithdrawalsPanel />
      case "settings":
        return <SettingsPanel />
      default:
        return <DashboardPanel />
    }
  }

  return (
    <div className="admin-dashboard">
      <AdminSidebar active={section} setActive={setSection} />
      <main className="admin-main">
        <header className="admin-header">
          <h1>Admin Dashboard</h1>
        </header>
        <section className="admin-panel-container">{renderPanel()}</section>
      </main>
    </div>
  )
}

export default Dashboard
